export const languageJourneyData = [
  { 
    "icon": "/images/Languages/jamaica-svgrepo-com.svg", 
    "label": "18 mos",
    "story": `Born in Jamaica, my first words were in Jamaican Patois. 
Growing up in a bilingual household, I naturally learned to switch between Patois and English at a young age.`
  },
  { 
    "icon": "/images/Languages/united-kingdom-svgrepo-com.svg", 
    "label": "9 yrs",
    "story": `Although I was exposed to English from birth, it wasn't until around age nine that I truly grasped all its grammar, pronunciation and nuances. 
That was also the year I passed my English literacy exam.`
  },
  { 
    "icon": "/images/Languages/spain-svgrepo-com.svg", 
    "label": "12 yrs",
    "story": `I had been around Spanish speakers since early childhood, but at twelve, I made a conscious effort to start absorbing the languages around me, Spanish being the first.`
  },
  { 
    "icon": "/images/Languages/france-svgrepo-com.svg", 
    "label": "15 yrs",
    "story": `After reaching what I believed was a decent level in Spanish, I decided to broaden my horizons and take up French. 
That enthusiasm didn't last long, though, as I quickly realized it wasn't as similar to Spanish as I had hoped.`
  },
  { 
    "icon": "/images/Languages/south-korea-svgrepo-com.svg", 
    "label": "21 yrs",
    "story": `After being accepted to study abroad at Yonsei University, I spent a few months learning the basics of Korean. 
Once in South Korea, I enrolled in the Korean Language Institute to deepen my understanding, and living there naturally helped me improve and pick up the language.`
  },
  { 
    "icon": "/images/Languages/germany-svgrepo-com.svg", 
    "label": "22 yrs",
    "story": `In my final year of college, after completing all my major requirements I took the opportunity to learn a new language, German.`
  },
]; 